import type { SiteId } from "./types";

export interface SiteConfig {
  id: SiteId;
  domain: string;
  title: string;
  claimNoun: string;
  startCents: number;
}

export const SITE_CONFIG: Record<SiteId, SiteConfig> = {
  earth: {
    id: "earth",
    domain: "outbid.earth",
    title: "Put your name on the planet",
    claimNoun: "country",
    startCents: 500,
  },
  shop: {
    id: "shop",
    domain: "outbid.shop",
    title: "The internet's loudest strip mall",
    claimNoun: "shopfront",
    startCents: 300,
  },
  homes: {
    id: "homes",
    domain: "outbid.homes",
    title: "Give your URL curb appeal",
    claimNoun: "home",
    startCents: 400,
  },
  land: {
    id: "land",
    domain: "outbid.land",
    title: "Digital dirt. Real bragging rights.",
    claimNoun: "parcel",
    startCents: 200,
  },
};

export function resolveSiteId(): SiteId {
  const injectedSite = document.documentElement.dataset.outbidSite;
  if (injectedSite && ["earth", "shop", "homes", "land"].includes(injectedSite)) {
    return injectedSite as SiteId;
  }

  const hostEnding = window.location.hostname.split(".").at(-1);
  if (hostEnding && ["earth", "shop", "homes", "land"].includes(hostEnding)) {
    return hostEnding as SiteId;
  }

  const firstPath = window.location.pathname.split("/").filter(Boolean)[0];
  if (firstPath && ["earth", "shop", "homes", "land"].includes(firstPath)) {
    return firstPath as SiteId;
  }

  return "earth";
}
